<template>
  <div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="less">
.base {
  color: @red;
}
.pb-60 {
  padding-bottom: 60px;
}
img {
  width: 100%;
}
.black {
  color: @black;
}
.white {
  color: @white;
}
.red {
  color: @red;
}
.blue {
  color: @blue;
}
.orange {
  color: @orange;
}
.orange-dark {
  color: @orange-dark;
}
.orange-light {
  color: @orange-light;
}
.green {
  color: @green;
}
.gray {
  color: @gray;
}
.gray-light {
  color: @gray-light;
}
.gray-darker {
  color: @gray-darker;
}
.gray-dark {
  color: @gray-dark;
}
.bg-black {
  background-color: @black;
}
.bg-white {
  background-color: @white;
}
.bg-red {
  background-color: @red;
}
.bg-blue {
  background-color: @blue;
}
.bg-orange {
  background-color: @orange;
}
.bg-orange-dark {
  background-color: @orange-dark;
}
.bg-orange-light {
  background-color: @orange-light;
}
.bg-green {
  background-color: @green;
}
.bg-gray {
  background-color: @gray;
}
.bg-gray-light {
  background-color: @gray-light;
}
.bg-gray-darker {
  background-color: @gray-darker;
}
.bg-gray-dark {
  background-color: @gray-dark;
}
</style>